import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { useToast } from '@/shared/contexts/ToastContext'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getErrorMessage } from '@/shared/utils/errorHandling'
import {
  actOnRemoteRequest,
  requestRemote,
  type RemoteAction,
} from '../apis/remoteGuidance'

// back の文言をそのまま出す。{"error": "..."} (依頼先なし・指導済の後 等) か、
// DRF の ValidationError (["..."]。既に依頼している・録音のある処方 等)
const messageOf = (error: unknown): string => {
  const data: unknown = axios.isAxiosError(error)
    ? error.response?.data
    : undefined
  if (typeof data === 'object' && data !== null && 'error' in data) {
    const text = (data as { error: unknown }).error
    if (typeof text === 'string') return text
  }
  if (Array.isArray(data) && typeof data[0] === 'string') return data[0]
  return getErrorMessage(error)
}

/** 依頼の操作。終わったら一覧と詳細を取り直して札を進める。失敗は toast に出す */
export const useRemoteGuidanceMutation = (yakurekiId: string) => {
  const queryClient = useQueryClient()
  const { showToast } = useToast()
  return useMutation({
    mutationFn: (
      args:
        | { action: 'request'; note: string }
        | { action: RemoteAction; remoteRequestId: string; note?: string }
    ) =>
      args.action === 'request'
        ? requestRemote(yakurekiId, args.note)
        : actOnRemoteRequest(args.remoteRequestId, args.action, args.note),
    onError: (error) => showToast(messageOf(error), 'error'),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['yakurekiList'] })
      queryClient.invalidateQueries({
        queryKey: queryKeys.yakureki.detail(yakurekiId),
      })
    },
  })
}
